import {createFileRoute, stripSearchParams} from '@tanstack/react-router'
import {zodValidator} from '@tanstack/zod-adapter'
import {z} from 'zod'
import {ContractorsPage} from '@/features/contractors/ContractorsPage'

export const defaultContractorsSearch = {
	page: 1,
	pageSize: 50,
	q: undefined as string | undefined,
}

export const contractorsSearchSchema = z.object({
	page: z.number().min(1).default(defaultContractorsSearch.page),
	pageSize: z
		.number()
		.min(1)
		.max(200)
		.default(defaultContractorsSearch.pageSize),
	q: z.string().optional(),
})

export type ContractorsSearch = z.output<typeof contractorsSearchSchema>

export const Route = createFileRoute('/contractors/')({
	component: ContractorsPage,
	validateSearch: zodValidator(contractorsSearchSchema),
	search: {
		middlewares: [stripSearchParams(defaultContractorsSearch)],
	},
})
